module.exports = __webpack_public_path__ + "media/application/images/home/events-20c52052975a5688ed552e9db22b2963.svg";